import {useCallback, useEffect, useState} from 'react';
import {Loading} from 'acud';

export default function UCWrap({initFunc}: {initFunc: () => Promise<any>}) {
    const [loading, setLoading] = useState(true);
    const init = useCallback(async () => {
        await initFunc();
        setLoading(false);
    }, [initFunc]);

    useEffect(() => {
        init();
    }, [init]);
    return (
        <>
            {loading && (
                <div className="loading-wrap">
                    <Loading />
                </div>
            )}
            <div id="login"></div>
        </>
    );
}
